import React, { useState } from "react"
import { useInView } from "react-intersection-observer"
import { Box } from "react-styled-flex"

import styles from "./styles.module.css"

type DisappearTopProps = {
	children: React.ReactNode
	delay?: number
	onView?: boolean
	playNow?: boolean
	short?: boolean
	opaque?: boolean
}

const DisappearTop = (props: DisappearTopProps) => {
	const { children, onView, playNow, delay, short, opaque } = props

	const { inView, ref } = useInView()
	const [play, setPlay] = useState(playNow || false)

	if (
		!play &&
		// if it uses `playNow`, already initialized correctly
		((onView === undefined && playNow) ||
			// render only when user sees, and is already `inView`
			(onView && inView) ||
			// no trigger specified, render immediately
			(onView === undefined && playNow === undefined))
	)
		setPlay(true)

	const getAnimateClass = () => {
		if (short && opaque) return styles["disappear-top-short-opaque"]
		if (short) return styles["disappear-top-short"]
		if (opaque) return styles["disappear-top-opaque"]
		return styles["disappear-top"]
	}

	const getDelayMaybe = (delayInSeconds?: number) =>
		delayInSeconds === undefined ? undefined : delayInSeconds + "s"

	const animateIf = (playIfTrue: boolean) =>
		playIfTrue ? getAnimateClass() : ""

	return (
		<Box ref={ref}>
			{
				<Box
					className={animateIf(play)}
					style={{
						animationDelay: getDelayMaybe(delay),
					}}>
					{children}
				</Box>
			}
		</Box>
	)
}

export default DisappearTop
